export class Csp5080Class {
    UserNam: string;
}
